/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box
} from '@mui/material';

const PolicyTable = () => {
  const data = [
    {
      company: '채널 코퍼레이션',
      risk: '고객 상담 및 고객 지원',
      period: '회원 탈퇴 또는 위탁 계약 만료시까지'
    },
    {
      company: 'KG 이니시스',
      risk: '결제정보(카드결제)',
      riskColgroup: 5,
      period: ''
    },
    { company: 'KSNet', risk: '', period: '' },
    {
      company: 'KICC',
      risk: '',
      period: ''
    },
    { company: '이지페이', risk: '', period: '' },
    { company: '나이스 페이먼츠', risk: '', period: '' },
    {
      company: 'AWS',
      risk: '데이터 보관 및 인프라 관리',
      period: ''
    },
    {
      company: '블룸에이아이',
      risk: '문자메시지 발송, 카카오톡 알림톡 발송 업무',
      period: ''
    },
    { company: '웹 프라자', risk: '쇼핑몰 플랫폼 운영 대행', period: '' },
    {
      company: '한비로',
      risk: 'SSL 보안인증서 서비스 제공',
      riskColgroup: 2,
      period: ''
    },
    { company: 'SETIGO', risk: '', period: '' },
    {
      company: '가비아',
      risk: '도메인 등록 서비스 제공',
      riskColgroup: 2,
      period: ''
    },
    { company: '후이즈', risk: '', period: '' }
  ];

  // Function to determine if a cell should be rendered or skipped
  const shouldRenderRiskCell = (index) => {
    // Check if this row is part of a previous row's span
    for (let i = 0; i < index; i++) {
      const prevRow = data[i];
      if (prevRow.riskColgroup && i + prevRow.riskColgroup > index) {
        return false;
      }
    }
    return true;
  };

  // Function to determine if a period cell should be rendered
  const shouldRenderPeriodCell = (index) => {
    // Only render the first period cell (it will span all rows)
    return index === 0;
  };

  return (
    <Box sx={{ width: '100%', maxWidth: 1200, margin: '0 auto', p: 2 }}>
      <TableContainer
        component={Paper}
        sx={{ border: '1px solid #ddd', boxShadow: 'none', borderRadius: 0 }}
      >
        <Table sx={{ minWidth: { md: 650 } }} aria-label="korean table">
          <TableHead>
            <TableRow
              sx={{
                th: {
                  borderBottom: '1px solid #ddd',
                  whiteSpace: 'pre-line',
                  wordBreak: 'keep-all',
                  overflowWrap: 'break-word'
                }
              }}
            >
              <TableCell
                align="center"
                sx={{
                  backgroundColor: '#f5f5f5',
                  fontWeight: 'bold',
                  borderRight: '1px solid #ddd',
                  width: { md: '20%' }
                }}
              >
                수탁 업체
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: '#f5f5f5',
                  fontWeight: 'bold',
                  borderRight: '1px solid #ddd',
                  width: { md: '50%' }
                }}
              >
                위탁업무 내용
              </TableCell>
              <TableCell
                align="center"
                sx={{
                  backgroundColor: '#f5f5f5',
                  fontWeight: 'bold',
                  width: '30%'
                }}
              >
                보유 및 이용기간
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '.MuiTableCell-root': {
                textAlign: 'center',
                py: 0,
                px: 1.5,
                height: '40px',
                lineHeight: '22px',
                borderBottom: '1px solid #ddd',
                fontSize: { md: '13px', xs: '12px' },
                whiteSpace: 'pre-line',
                wordBreak: 'keep-all',
                overflowWrap: 'break-word'
              }
            }}
          >
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  'td:not(:last-child), th:not(:last-child)': {
                    borderRight: '1px solid #ddd'
                  }
                }}
              >
                <TableCell
                  align="center"
                  sx={{
                    fontSize: '14px'
                  }}
                >
                  {row.company}
                </TableCell>

                {/* Risk column with rowspan logic */}
                {shouldRenderRiskCell(index) && (
                  <TableCell
                    align="center"
                    rowSpan={row.riskColgroup || 1}
                    sx={{
                      fontSize: '14px',
                      verticalAlign: 'middle',
                      borderLeft: '1px solid #ddd',
                      borderBottom:
                        index === data.length - 2 && '0px !important'
                    }}
                  >
                    {row.risk}
                  </TableCell>
                )}

                {/* Period column - first cell spans all rows */}
                {shouldRenderPeriodCell(index) && (
                  <TableCell
                    align="center"
                    rowSpan={data.length}
                    sx={{
                      fontSize: '14px',
                      borderLeft: '1px solid #ddd',
                      verticalAlign: 'middle',
                      borderBottom: '0px !important'
                    }}
                  >
                    {row.period}
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PolicyTable;
